import React, { PureComponent } from "react";
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class InputLimit extends PureComponent {

    /**
     * 
     * @param {any} event
     */
    onChangeLimiteFinanciacion(event) {
        /*Obtengo el valor*/
        let value = event.target.value;
        /*Saco las letras en caso de que hayan pegado un texto y lo transformo en numero*/
        value = parseInt(value.replace(/\D/g, ""));
        /*Si no es un numero, entonces actualizo el estado con un vacio*/
        if (isNaN(value)) {
            this.props.guardarCampoCuenta("", "LimiteFinanciacion");
        } else {
            /*De lo contrario pregunto si el numero ingresado es mayor a 100, si lo es, lo fuerzo a 100 de lo contrario lo guardo*/
            value = value > 100 ? 100 : value;
            this.props.guardarCampoCuenta(value, "LimiteFinanciacion");
        }
    }

    /**
     * 
     * @param {any} event
     */
    onKeyPressSoloNumeros(event) {
        const permiteComa = event.target.dataset.coma;
        const value = event.target.value;
        let validarNumeros = true;

        if (permiteComa == "true" && event.charCode == 44) {
            validarNumeros = false;

            if (value.indexOf(",") > -1) {
                event.preventDefault();
            }
        }

        /*Valido Numeros y comas si es necesario*/
        if ((/\d/g).test(event.key) == false && validarNumeros == true) {
            event.preventDefault();
        }
    }

    /**
     * 
     * @param {any} val
     */
    onKeyPressFactor(val) {
        let n = val.key;
    }

    /**
     * 
     * @param {any} event
     */
    onChangeFlcc(event) {   
        /*Obtengo el valor*/
        let value = event.target.value;
        this.props.guardarCampoCuenta(value, "Flcc");
    }

    render() {

        const { Cuenta, edicion } = this.props;
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;

        if (!edicion) {
            errorContainer = <label className="error">
                {(errors = getFieldError('FLCC')) ? errors.join(',') : null}</label>
        } else {
            errorContainer = <label className="error">
                {(errors = getFieldError('FLCC')) ?
                    this.props.form.isFieldTouched("FLCC") ?
                        errors.join(',') : null
                    : null}</label>
        }

        let limiteFinanciacionEsModificable = Cuenta.LimiteFinanciacionEsModificable;
        let flccEsModificable = Cuenta.FlccEsModificable;

        const limiteComponente = (limiteFinanciacionEsModificable == true)
            ? <input type="text" value={Cuenta.LimiteFinanciacion}
                maxLength="3" className="form-control default-input"
                onChange={this.onChangeLimiteFinanciacion.bind(this)}
                onKeyPress={this.onKeyPressSoloNumeros.bind(this)} />

            : <label className="label-secondary">{Cuenta.LimiteFinanciacion}</label>;

        const flccComponente = (flccEsModificable == true)
            ? <div>
                <GenericInputValidate
                    getFieldProps={getFieldProps('FLCC', {
                        onChange(e) {
                            me.onChangeFlcc(e);
                        },
                        rules: [{
                            required: true,
                            pattern: /^(?=.*[1-9])\d{0,2}(?:\.\d{0,1})?$/,
                            message: 'Debe ingresar FLCC válido(0.1 - 99.9).'
                        }]
                    })}
                    id="FLCC"
                    name="FLCC"
                    className="form-control default-input"
                    value={Cuenta.Flcc}
                    maxLength="4" 
                />
                {errorContainer}
            </div>
            : <label className="label-secondary">{Cuenta.Flcc}</label>;

        return (
            <div className="bottom-separator-xs">
                <div className="row bottom-separator-xxs">
                    <div className="col-xs-12">
                        <label className="label-primary">Límite de financiación</label>
                    </div>
                    <div className="col-xs-2">
                        {limiteComponente}
                    </div>
                    <div className="col-xs-10">% límite de la cuenta</div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <label className="label-primary">Factor de límite de compra en cuotas (FLCC)</label>
                    </div>
                    <div className="col-xs-2">
                        {flccComponente}
                    </div>
                </div>
            </div>
        );
    }
};

export default InputLimit;